import {combineReducers} from "redux";
import analyzeReport from "./analyzeReport";

const analyzeConfigReducer = combineReducers({
    analyzeReport
});

export default analyzeConfigReducer;
